import { render, staticRenderFns } from "./NoCommunicationsMessage.vue?vue&type=template&id=001671a2&scoped=true"
import script from "./NoCommunicationsMessage.vue?vue&type=script&lang=js"
export * from "./NoCommunicationsMessage.vue?vue&type=script&lang=js"
import style0 from "./NoCommunicationsMessage.vue?vue&type=style&index=0&id=001671a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001671a2",
  null
  
)

export default component.exports